import React from "react";
import moment from "moment";
import * as FaIcons from "react-icons/fa";
import { Link } from "react-router-dom";

const LeloFormCard = ({
  info: {
    _id,
    createdAt,
    status,
    firstName,
    lastName,
    studentEmail,
    studentPrimaryPhone,
    learningCenters,
  },
}) => {
  const getStatusStyle = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return { color: '#537131', fontWeight: '600' };
      case 'inactive':
        return { color: '#dc3545', fontWeight: '600' };
      case 'signed':
        return { color: '#0d6efd', fontWeight: '600' };
      default:
        return { color: '#6c757d', fontWeight: '600' };
    }
  };

  return (
    <Link to={`/lelo-forms/${_id}`} className="interest-form-card">
      <div className="top">
        <div className="left">
          <div className="name">
            <h2>{firstName} {lastName}</h2>
          </div>
          <FaIcons.FaUserCircle className="form-card-icon" />
        </div>
        {/* <div className="right">
          <h3 style={getStatusStyle(status)}>{status || "N/A"}</h3>
        </div> */}
      </div>
      <div className="body">
        <div className="item">
          <h4>Status:</h4>
          <p>{status}</p>
        </div>
        <div className="item">
          <h4>Submit Date:</h4>
          <p>{moment(createdAt).format("MM/DD/YYYY")}</p>
        </div>
        <div className="item">
          <h4>Learning Center:</h4>
          <p>{learningCenters}</p>
        </div>
        {/* <div className="item">
          <h4>Master Agreement:</h4>
          <p>{masteragreement}</p>
        </div> */}
        <div className="item">
          <h4>Phone:</h4>
          <p>{studentPrimaryPhone}</p>
        </div>
        <div className="item">
          <h4>Email:</h4>
          <p>{studentEmail}</p>
        </div>
      </div>
    </Link>
  );
};

export default LeloFormCard;
